import styled from "styled-components";

export default styled.img`
  width: 100%;
  height:275px;
  object-fit:cover;
`;
